var map = {
	"./EDU_staff_PP.jpg": "ce94",
	"./FB.svg": "9c97",
	"./INS.svg": "66b3",
	"./LIN.svg": "592e",
	"./TW.svg": "1690",
	"./Upload.png": "9b97",
	"./UploadFailed.png": "9087",
	"./WEB.svg": "6dc0",
	"./avatar-icon.svg": "d2d9",
	"./avatar-upload-icon.svg": "0069",
	"./avg_score.svg": "3e33",
	"./chat.svg": "1666",
	"./check.svg": "e7d6",
	"./comments.svg": "595a",
	"./completed.svg": "8bd5",
	"./continue_the_quiz.svg": "c27b",
	"./course_update.svg": "ca55",
	"./document.svg": "1344",
	"./download.svg": "0339",
	"./edit.svg": "c560",
	"./empty_cr.svg": "498a7",
	"./empty_flex.svg": "0286",
	"./empty_holiday.svg": "f912",
	"./empty_teaching_staff.svg": "8ad7",
	"./enter_VC_icon.svg": "5712",
	"./error-upload.png": "25ae",
	"./excmark.svg": "53ec",
	"./forum.svg": "9159",
	"./group-work.svg": "60ea",
	"./head-icon.png": "07d4",
	"./library-icons/Audio.svg": "875e",
	"./library-icons/Cards.svg": "853f",
	"./library-icons/Video.svg": "c328",
	"./library-icons/Website.svg": "cce5",
	"./library-icons/bookmark_I.svg": "7968",
	"./library-icons/bookmark_II.svg": "2947",
	"./library-icons/free-access-books.svg": "a781",
	"./library-icons/full-text-papers.svg": "43f0",
	"./library-icons/interactive.svg": "185f",
	"./library-icons/learning-platforms.svg": "30c9",
	"./list_icon.png": "c862",
	"./medical-subjects/aging.svg": "9622",
	"./medical-subjects/anatomy.svg": "e501",
	"./medical-subjects/biology.svg": "365e",
	"./medical-subjects/clinical_medicine.svg": "aa3a",
	"./medical-subjects/clinical_rotation.svg": "b524",
	"./medical-subjects/collaborator.svg": "4469",
	"./medical-subjects/communicator.svg": "7a40",
	"./medical-subjects/dermatology.svg": "e82a",
	"./medical-subjects/ebm.svg": "8a04",
	"./medical-subjects/elective.svg": "9dc4",
	"./medical-subjects/embryology.svg": "7bfc",
	"./medical-subjects/emergency_medicine_anesthesia.svg": "f03a",
	"./medical-subjects/ent.svg": "d9a0",
	"./medical-subjects/general_practice.svg": "7899",
	"./medical-subjects/gynaecology.svg": "daec",
	"./medical-subjects/health_advocate.svg": "27cd",
	"./medical-subjects/human_genetics.svg": "360c",
	"./medical-subjects/hygiene.svg": "ba56",
	"./medical-subjects/internal_medicine.svg": "2550",
	"./medical-subjects/laboratory.svg": "a55c",
	"./medical-subjects/leader.svg": "b39e",
	"./medical-subjects/medical_english.svg": "0182",
	"./medical-subjects/medical_ethics.svg": "a6f0",
	"./medical-subjects/medical_expert.svg": "4ddc",
	"./medical-subjects/medical_sociology.svg": "0c85",
	"./medical-subjects/mentoring.svg": "5965",
	"./medical-subjects/microbiology.svg": "4935",
	"./medical-subjects/neurology.svg": "b784",
	"./medical-subjects/none.svg": "f26d",
	"./medical-subjects/nursing_skills.svg": "2c60",
	"./medical-subjects/onboarding.svg": "f1f8",
	"./medical-subjects/oncology_palliative_care.svg": "4636",
	"./medical-subjects/ophthalmology.svg": "2cbb",
	"./medical-subjects/pathology.svg": "90f6",
	"./medical-subjects/pediatrics.svg": "8e46",
	"./medical-subjects/pharmacology.svg": "2725",
	"./medical-subjects/physics_chemistry_biochemistry.svg": "bc8c",
	"./medical-subjects/physiology.svg": "fc40",
	"./medical-subjects/practical_procedures_skills.svg": "5e04",
	"./medical-subjects/professional.svg": "8da8",
	"./medical-subjects/professionalism.svg": "0d53",
	"./medical-subjects/psychiatry.svg": "fad1",
	"./medical-subjects/research_track.svg": "ef05",
	"./medical-subjects/scholar.svg": "a969",
	"./medical-subjects/srl.svg": "262d",
	"./medical-subjects/surgery.svg": "8540",
	"./medical-subjects/traumatology.svg": "af6d",
	"./medical-subjects/urology.svg": "fe3a",
	"./msg.svg": "0b9e",
	"./nav_arrow.svg": "6984",
	"./nav_cr.svg": "a814",
	"./nav_cr_selected.svg": "821e",
	"./nav_flex.svg": "6cbb",
	"./nav_flex_selected.svg": "c96c",
	"./nav_study.svg": "f2f0",
	"./nav_study_selected.svg": "dbec",
	"./new_thread.svg": "754a",
	"./newrow_logo.svg": "2803",
	"./not_saved.svg": "033e",
	"./outcomes.svg": "3994",
	"./placeholder_newsfeed.svg": "092f",
	"./reactions.svg": "baea",
	"./remove.svg": "8010",
	"./reply.svg": "c48d",
	"./report_problem.svg": "0d73",
	"./retake_the_quiz.svg": "1e8d",
	"./retry.svg": "db79",
	"./saved.svg": "0081",
	"./saving.svg": "94c3",
	"./self_assessment.svg": "1f5e",
	"./space-ship.png": "1d0d",
	"./student.svg": "1c47",
	"./time-off-day.png": "90fa",
	"./time-off-early-late.png": "ed3d",
	"./time-off-night.png": "aea1",
	"./time-off.png": "0382",
	"./two-envelopes.svg": "b98d",
	"./undefined.svg": "c2d3",
	"./view.svg": "84bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";